import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=2800ccaa&scoped=true&"
import script from "./MainView.vue?vue&type=script&lang=ts&"
export * from "./MainView.vue?vue&type=script&lang=ts&"
import style0 from "./MainView.vue?vue&type=style&index=0&id=2800ccaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2800ccaa",
  null
  
)

export default component.exports